import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { candidateApi, SESSION_EXPIRED_EVENT } from '../services/pspApi';
import { clearCandidateSession, getCandidateToken, setCandidateToken } from '../services/pspSession';

const PspAuthContext = createContext(null);

export const PspAuthProvider = ({ children }) => {
    const [candidate, setCandidate] = useState(null);
    const [loading, setLoading] = useState(!!getCandidateToken());

    useEffect(() => {
        const loadCandidate = async () => {
            if (!getCandidateToken()) {
                setLoading(false);
                return;
            }
            const result = await candidateApi.me();
            if (result && result.status === 1) {
                setCandidate(result.candidate);
            } else {
                clearCandidateSession();
            }
            setLoading(false);
        };
        loadCandidate();
    }, []);

    useEffect(() => {
        const onExpired = () => setCandidate(null);
        window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
        return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
    }, []);

    const signIn = useCallback((token, candidateData) => {
        setCandidateToken(token);
        setCandidate(candidateData);
    }, []);

    const signOut = useCallback(async () => {
        await candidateApi.logout();
        clearCandidateSession();
        setCandidate(null);
    }, []);

    const value = useMemo(
        () => ({ candidate, loading, isAuthenticated: !!candidate, signIn, signOut, setCandidate }),
        [candidate, loading, signIn, signOut]
    );

    return <PspAuthContext.Provider value={value}>{children}</PspAuthContext.Provider>;
};

export const usePspAuth = () => useContext(PspAuthContext);
